<template>
  <v-row>
    <v-col cols="8" sm="10">
      <v-radio-group
        v-model="facilityType"
        :hint="`${facilityType}`"
        dense
        label="Pool Type"
        row
      >
        <v-radio label="25m" value="25m"></v-radio>
        <v-radio label="50m" value="50m"></v-radio>
        <v-radio label="25y" value="25y"></v-radio>
      </v-radio-group>
    </v-col>
  </v-row>
  <!--  CALL COMPONENT FROM PARENT EXAMPLE
 import SwimmingFacilitiesSize from "../shared/swimming_facilities_size_radio.vue";
   <SwimmingFacilitiesSize :facilityType ="facilityType" v-on:change-facility="onChangeFacility"/> -->
</template>

<script>
export default {
  props: {
    parentFacilityType: {
      type: String,
      default: "25m"
    }
  },
  data() {
    return {
      facilityType: "50m"
    };
  },
  computed: {
    if(facilityType) {
      facilityType = this.parentFacilityType;
      return facilityType;
    }
  },
  created() {
    this.$emit("change-facility", this.facilityType);
    if (!(Object.entries(this.$route.query).length === 0)) {
      const { facilityType } = this.$route.query;
      //assign to current instance variables

      this.facilityType = facilityType;
    }
  },
  //  computed: {
  //      facilityType() {
  //        return this.parentFacilityType;
  //      }
  //    },
  methods: {
    // Define the method that emits data to the parent as the first parameter to `$emit()`.
    // This is referenced in the <template> call in the parent. The second parameter is the payload.
    // emitToParent (eevnt) {
    //   this.$emit('childToParent', this.childMessage)
    // }
  },
  watch: {
    facilityType: function() {
      this.$emit("change-facility", this.facilityType);
    }
  }
};
</script>
